// pages/Team.js
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MyNavbar from '../components/MyNavbar';
import Footer from '../components/Footer';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Team = () => {
    return (
        <div className="team-page">
            <MyNavbar />

            {/* Hero Section */}
            <section style={{
                backgroundColor: '#0A4B5D',
                color: 'white',
                paddingTop: '5rem',
                paddingBottom: '3rem'
            }}>
                <Container>
                    <Row className="text-center">
                        <Col lg={8} className="mx-auto">
                            <h1 className="display-4 fw-bold mb-4">Our Team</h1>
                            <p className="lead">
                                Meet the researchers and collaborators driving innovation in translational bioinformatics
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Principal Investigator */}
            <section className="py-5">
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-5 fw-bold mb-3" style={{ color: '#0A4B5D' }}>
                                Principal Investigator
                            </h2>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <Card className="shadow border-0">
                                <Card.Body className="p-4">
                                    <Row>
                                        <Col md={4} className="text-center">
                                            <div className="team-photo mb-3">
                                                <img
                                                    src="/images/Trupti.jpg"
                                                    alt="Dr. Trupti Joshi"
                                                    className="rounded-circle img-fluid"
                                                    style={{
                                                        width: '200px',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        border: '4px solid #0A4B5D'
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={8}>
                                            <h3 style={{ color: '#0A4B5D' }}>Dr. Trupti Joshi</h3>
                                            <h5 className="text-muted mb-3">Senior Associate Dean for Informatics & Population Analytics</h5>
                                            <div className="mb-3">
                                                <h6 style={{ color: '#0A4B5D' }}>Education</h6>
                                                <ul className="list-unstyled">
                                                    <li><i className="bi bi-mortarboard-fill me-2 text-primary"></i>MBBS, ADB, MS, Ph.D.</li>
                                                </ul>
                                            </div>

                                            <div className="mb-3">
                                                <h6 style={{ color: '#0A4B5D' }}>Academic Positions</h6>
                                                <ul className="list-unstyled">
                                                    <li><i className="bi bi-briefcase-fill me-2 text-primary"></i>Senior Associate Dean for Informatics & Population Analytics</li>
                                                    <li><i className="bi bi-building me-2 text-primary"></i>Department of Biomedical Sciences, Marshall University</li>
                                                    <li><i className="bi bi-person-badge-fill me-2 text-primary"></i>Adjunct Associate Professor, University of Missouri-Columbia</li>
                                                    <li style={{ paddingLeft: '20px' }}>- Biomedical Informatics, Biostatistics & Medical Epidemiology (BBME)</li>
                                                    <li style={{ paddingLeft: '20px' }}>- Electrical Engineering & Computer Science (EECS)</li>
                                                </ul>
                                            </div>

                                            <div className="mb-3">
                                                <h6 style={{ color: '#0A4B5D' }}>Profiles</h6>
                                                <div className="d-flex gap-3">
                                                    <a href="https://www.linkedin.com/in/trupti-joshi-9552ba17/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                        <i className="fab fa-linkedin me-1"></i> LinkedIn
                                                    </a>
                                                    <a href="https://scholar.google.com/citations?user=Pyt_mlAAAAAJ&hl=en&oi=ao" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                        <i className="fas fa-graduation-cap me-1"></i> Google Scholar
                                                    </a>
                                                    <a href="https://www.ncbi.nlm.nih.gov/myncbi/trupi.joshi.1/bibliography/public/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                        <i className="fas fa-book-medical me-1"></i> PubMed
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <h6 style={{ color: '#0A4B5D' }}>Contact</h6>
                                                <p className="mb-1">
                                                    <i className="fas fa-envelope me-2"></i>
                                                    joshitr@marshall.edu
                                                </p>
                                                <p className="mb-0">
                                                    <i className="fas fa-map-marker-alt me-2"></i>
                                                    Joan C. Edwards School of Medicine, Marshall University, Huntington, WV 25755
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="py-5 bg-light">
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-5 fw-bold mb-3" style={{ color: '#0A4B5D' }}>
                                Current Team Members
                            </h2>
                        </Col>
                    </Row>

                    <Row className="mb-5">
                        <Col>
                            <h3 className="text-center mb-4" style={{ color: '#0A4B5D' }}>Research Team</h3>
                            <Row className="justify-content-center">
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/Mohit.jpg"
                                                    alt="Dr. Mohit Verma"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Dr. Mohit Verma</Card.Title>
                                            <Card.Text className="text-muted mb-2">Research Assistant Professor</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/mohit-verma-phd-879a531b/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?hl=en&user=xD-lhrkAAAAJ" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/VahedMohammad.jpg"
                                                    alt="Mohammad Vahed"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Mohammad Vahed</Card.Title>
                                            <Card.Text className="text-muted mb-2">Research Assistant Professor</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/mohammad-vahed-53485530/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?hl=en&user=DnmX9wYAAAAJ" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/Yen.jpg"
                                                    alt="Dr. Yen On Chan"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Dr. Yen On Chan</Card.Title>
                                            <Card.Text className="text-muted mb-2">Post Doctoral Fellow</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/yen-on-chan/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?hl=en&user=vSrsKXEAAAAJ" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/ZhenLyu.jpg"
                                                    alt="Zhen Lyu"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Zhen Lyu</Card.Title>
                                            <Card.Text className="text-muted mb-2">Post Doctoral Fellow</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/zhen-lyu-182a4921a/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?hl=en&user=izwaXNIAAAAJ" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/SaiPreethi.jpg"
                                                    alt="Sai Preethi Induri"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Sai Preethi Induri</Card.Title>
                                            <Card.Text className="text-muted mb-2">Senior Research Specialist</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/saipreethiinduri/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?hl=en&user=Q2cH4dIAAAAJ" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/SabinDahal.png"
                                                    alt="Sabin Dahal"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Sabin Dahal</Card.Title>
                                            <Card.Text className="text-muted mb-2">Software and Web Developer</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/sabindahal99/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?user=BS0jldYAAAAJ&hl=en&oi=ao" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col lg={4} md={6} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 team-member-card">
                                        <Card.Body className="text-center p-4">
                                            <div className="team-member-photo mb-3">
                                                <img
                                                    src="/images/ChunyangLu.jpg"
                                                    alt="Chunyang Lu"
                                                    className="rounded-circle img-fluid"
                                                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Card.Title style={{ color: '#0A4B5D' }}>Chunyang Lu</Card.Title>
                                            <Card.Text className="text-muted mb-2">Graduate Research Assistant (PhD Student)</Card.Text>
                                            <div className="d-flex justify-content-center gap-3 mt-3">
                                                <a href="https://www.linkedin.com/in/chunyang-lu-b862b788/" className="text-decoration-none" title="LinkedIn" target="_blank">
                                                    <i className="fab fa-linkedin fa-lg" style={{ color: '#0077b5' }}></i>
                                                </a>
                                                <a href="https://scholar.google.com/citations?hl=en&user=vuq2C8gAAAAJ&view_op=list_works&sortby=title" className="text-decoration-none" title="Google Scholar" target="_blank">
                                                    <i className="fas fa-graduation-cap fa-lg" style={{ color: '#4285f4' }}></i>
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
        </div>
    );
};

export default Team;